const opacityChange = () => {
  var colorTxt = document.querySelectorAll('.p-top__message__text');
    if(colorTxt != null) {
    function applyOpacity(element) {
      const text = element.innerText;
      element.innerHTML = '';

      Array.from(text).forEach((char, index) => {
        const span = document.createElement('span');
        span.innerText = char;
        span.style.animationDelay = `${index * 0.03
        }s`;
        span.classList.add('change-opacity');
        element.appendChild(span);
      });
    }
    document.querySelectorAll('strong').forEach(applyOpacity);
  }
}
